import React, { useState, useEffect, useRef, useCallback } from 'react';
import { setChildren } from 'redom';

import application from 'application';
import internalEventCodes from 'event-system/codes/internal';

import { ReactComponent as CheckIcon } from 'assets/images/check-toast-icon.svg';
import { ReactComponent as CloseIcon } from 'assets/images/close-toast-icon.svg';
import { ReactComponent as WarnIcon } from 'assets/images/info-tip-icon.svg';

import './index.scss';

function SystemToastMessage() {

  const messageTextReference = useRef(null);

  const [state, setState] = useState({
    remainingSeconds: 0,
    message: 'TestMessage',
    type: 'info'
  });

  const timerCallback = useCallback(function timerCallback() {

    setState(function updateState(state) {

      if (state.remainingSeconds === 0) {
        return state;
      }

      return {
        ...state,
        remainingSeconds: state.remainingSeconds - 1
      };

    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(function registerForEvents() {

    const unlistenDisplaySystemToastMessageEvent = listenToDisplaySystemToastMessageEvent();
    const unlistenHideSystemToastMessageEvent = listenToHideSystemToastMessageEvent();
    const unlistenToExceptionMessageEvent = listenToExceptionMessageEvent();
    const timerReference = setInterval(timerCallback, 1000);

    return function unregisterEventListeners() {
      unlistenDisplaySystemToastMessageEvent();
      unlistenHideSystemToastMessageEvent();
      unlistenToExceptionMessageEvent();
      clearInterval(timerReference);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function updateMessage(state) {

    const messageElement = messageTextReference.current;

    if (typeof state.message !== 'string') {
      setChildren(messageElement, [state.message]);
      if (typeof state.message.setHandle === 'function') {
        state.message.setHandle({
          close: hideSystemToastMessage
        });
      }
    } else {
      messageElement.textContent = state.message;
    }

  }

  function hideSystemToastMessage() {

    setState(function updateState() {

      return {
        remainingSeconds: 0
      };

    });

  }

  function updateState(newState, oldState) {

    return {
      ...newState,
      remainingSeconds: newState.seconds || 5,
      type: newState.type || 'info'
    };

  }

  function listenToDisplaySystemToastMessageEvent() {

    function handleDisplaySystemToastMessageEvent(data) {
      updateMessage(data);
      setState(updateState.bind(null, data));
    }

    application.eventSystem.internal.on(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, handleDisplaySystemToastMessageEvent);

    return function unlistenDisplaySystemToastMessageEvent() {
      application.eventSystem.internal.off(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, handleDisplaySystemToastMessageEvent);
    };

  }

  function listenToHideSystemToastMessageEvent() {

    function handleHideSystemToastMessageEvent() {
      setState(function updateState() {
        return { remainingSeconds: 0 };
      });
    }

    application.eventSystem.internal.on(internalEventCodes.HIDE_SYSTEM_TOAST_MESSAGE, handleHideSystemToastMessageEvent);

    return function unlistenHideSystemToastMessageEvent() {
      application.eventSystem.internal.off(internalEventCodes.HIDE_SYSTEM_TOAST_MESSAGE, handleHideSystemToastMessageEvent);
    };

  }

  function listenToExceptionMessageEvent() {

    function handleExceptionMessageEvent(data) {
      // clearTimeout(timerReferenceStore.current);
      application.constructor.logError(data.error.type, data.error.exception);
      setState(updateState.bind(null, data.message));
    }

    application.eventSystem.internal.on(internalEventCodes.LOG_EXCEPTION_AND_DISPLAY_ERROR_TOAST_MESSAGE, handleExceptionMessageEvent);

    return function unlistenExceptionMessageEvent() {
      application.eventSystem.internal.off(internalEventCodes.LOG_EXCEPTION_AND_DISPLAY_ERROR_TOAST_MESSAGE, handleExceptionMessageEvent);
    };

  }

  function renderToastIcon() {

    if (state.type === 'info') {
      return <CheckIcon />;
    }

    if (state.type === 'progress') {
      return <ht-spinner size="small"/>;
    }

    if (state.type === 'warn') {
      return <WarnIcon />;
    }

    return <CloseIcon onClick={hideSystemToastMessage} />;

  }

  function renderToastMessage() {

    const toastMessageAttributes = {
      id: 'system-toast-message-display',
      className: state.type
    };
    if (state.remainingSeconds === 0) {
      toastMessageAttributes.className += ' hidden';
    }
    const messageTextAttributes = {
      className: 'system-toast-message-text',
      ref: messageTextReference
    };

    return <div {...toastMessageAttributes}>
      {renderToastIcon()}
      <p {...messageTextAttributes}></p>
    </div>;

  }

  return <div id="system-toast-message-main">
    {renderToastMessage()}
  </div>;

}

export default SystemToastMessage;